import ApiManager from "./axios-config";
import authHeader from "./auth-header";
import URL from "./APIURL";
const API_URL = URL + "/help/";

class HelpService {
  getHelpContent(lang, page) {
    const params = {
      lang,
      page,
    };
    return ApiManager.get(API_URL, {
      headers: { Authorization: authHeader() },
      params,
    });
  }
  postHelpContent(payload) {
    return ApiManager.post(API_URL, payload, {
      headers: { Authorization: authHeader() },
    });
  }
  putHelpContent(payload) {
    return ApiManager.put(API_URL, payload, {
      headers: { Authorization: authHeader() },
    });
  }
}

export default new HelpService();
